import { useState, useEffect, useRef } from 'react';

const API = import.meta.env.VITE_API_BASE || '/api';
const REFRESH_MS = 5 * 60 * 1000; // poll every 5 min; backend already caches

// Returns { count, people, fetched_at, prevCount, justChanged }
// `justChanged` is true for ~10s after a count change so the UI can flash.
export function useHumansInSpace() {
  const [state, setState] = useState({
    count: null, people: [], fetched_at: null,
    prevCount: null, justChanged: false,
  });
  const prevCountRef = useRef(null);
  const flashTimerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    async function tick() {
      try {
        const r = await fetch(`${API}/people-in-space`);
        if (!r.ok) return;
        const d = await r.json();
        if (cancelled) return;
        const justChanged = prevCountRef.current != null && d.count !== prevCountRef.current;
        setState({
          count: d.count,
          people: d.people || [],
          fetched_at: d.fetched_at,
          prevCount: prevCountRef.current,
          justChanged,
        });
        prevCountRef.current = d.count;
        if (justChanged) {
          if (flashTimerRef.current) clearTimeout(flashTimerRef.current);
          flashTimerRef.current = setTimeout(() => {
            setState(s => ({ ...s, justChanged: false }));
          }, 10_000);
        }
      } catch { /* network blip -- retain last value */ }
    }

    tick();
    const id = setInterval(tick, REFRESH_MS);
    return () => { cancelled = true; clearInterval(id); if (flashTimerRef.current) clearTimeout(flashTimerRef.current); };
  }, []);

  return state;
}
